import React from "react";
import { Footer } from "./footer";
import { Header } from "./header";
import { Banner } from "../ui/Banner";

export interface LayoutProps extends React.HTMLAttributes<HTMLDivElement> {
  children: React.ReactNode;
}

export const Layout: React.FC<LayoutProps> = ({ children, ...props }) => {
  return (
    <div className="flex min-h-screen flex-col bg-background">
      <Header />
      <Banner />
      <main className="flex h-full flex-1">{children}</main>
      <Footer />
    </div>
  );
};
